export default {
  methods: {
    // 处理服务端返回的表头数据
    dealColumns(data) {
      if (!data) {
        return
      }
      let columns = []
      const fixedArr = ['deptName', 'carBrandName', 'carSeriesName', 'carModelName']
      columns = data.map((item) => {
        return {
          name: item.titleCode,
          columnProps: {
            label: item.titleName,
            prop: item.titleCode,
            fixed: fixedArr.includes(item.titleCode),
            width: fixedArr.includes(item.titleCode) ? 140 : '',
          },
        }
      })
      return columns
    },
    // 表格自定义渲染函数
    renderContent(configObj = { label: 'span', value: '', className: '' }) {
      return this.$createElement(configObj.label, {
        class: configObj.className,
        on: {
          click: configObj.fn || '',
        },
      }, configObj.value)
    },
    // 单元格合并
    cellMerge(tableData, { rowIndex }) {
      if (!tableData?.length) return [0, 0]

      const rowArr = []
      let rowPosition = 0

      // 处理第一行 - 修正：单行数据时应该返回1而不是0
      rowArr.push(1)

      // 处理后续行
      for (let i = 1; i < tableData.length; i++) {
        const currentDeptId = tableData[i].deptId
        const prevDeptId = tableData[i - 1].deptId

        if (currentDeptId === prevDeptId) {
          rowArr[rowPosition] += 1
          rowArr.push(0)
        } else {
          rowArr.push(1)
          rowPosition = i
        }
      }

      const rowNum = rowArr[rowIndex]
      const columnNum = rowNum > 0 ? 1 : 0

      return [rowNum, columnNum]
    },
  },
}
